import type { AIDTColor } from './_typing';

export const orange: AIDTColor = Object.freeze({
  50: '#fff3e0',
  100: '#FAE5DC',
  200: '#F5CAB9',
  300: '#EFB096', // social elementary key
  400: '#EA9573',
  500: '#E57B50', // social middle key
  600: '#D06C47',
  700: '#BA5D3D',
  800: '#A54D34',
  900: '#5F291D', //social high bg
  950: '#1B3F17',
  0: '#30150E', // social high key
} as const);
